import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

function checkUserUniqueness(type, value) {
  return apollo.client.query({
    variables: {
      [type]: value,
    },
    query: gql`
        query User($${type}: String!) {
          checkUserUniqueness(${type}: $${type})
        }
    `,
    fetchPolicy: 'network-only',
  }).then((res) => ({ ...res }));
}

export default checkUserUniqueness;
